import {
    Button, Col,
    Drawer, Form, Input,
    Row,
    notification
} from 'antd';
import { useEffect, useState } from 'react';
import { ActionType } from '../../constants/actionType';
import { createCollectionConfig, updateCollectionConfig } from '../../helpers/api/storyCollectionConfig';

const storyCollectionDrawerValidation = {
    name: [
        {required: true, message: 'Name is required'},
        {max: 100, message: 'Name must be less than 100 characters'},
    ],
    dayIndexMin: [
        {required: true, message: 'Day MIN is required'},
    ],
    dayIndexMax: [
        {required: true, message: 'Day MAX is required'},
    ]
}

const CollectionConfigDrawer = ({
                         drawerVisibility,
                         setdDrawerVisibility,
                         collectionConfig,
                         actionType,
                         setActionType,
                         onSuccess,
                         onFailure
                     }: any) => {

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);

    const [submittables, setSubmittable] = useState<boolean>(false);
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

    const [ currentConfig, setCurrentConfig ] = useState<any>();

    useEffect(() => {
        console.log('collectionConfig: ', collectionConfig)
        if (collectionConfig) {
            form.setFieldValue("name", collectionConfig.name);
            form.setFieldValue("dayIndexMin", collectionConfig.dayIndexMin);
            form.setFieldValue("dayIndexMax", collectionConfig.dayIndexMax);

            setCurrentConfig(collectionConfig);
        }
    }, [collectionConfig]);

    useEffect(() => {
        form.setFieldValue("configName", currentConfig?.name );
        form.setFieldValue("dayIndexMin", currentConfig?.config?.dayIndexMin);
        form.setFieldValue("dayIndexMax", currentConfig?.config?.dayIndexMax );
    }, [currentConfig])


    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        form.validateFields({validateOnly: true})
            .then(
                () => {
                    setSubmittable(true)
                },
                () => {
                    setSubmittable(false)
                },
            );
    }, [formValueObj]);

    

    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    const onClose = () => {
        form.resetFields();
        setCurrentConfig(null);
        form.setFieldValue("status", "inactive");
        setSubmittable(false);
        setdDrawerVisibility(false);
        setActionType("");
    }

    const saveConfig = async () => {
        try {
            const requestModel = {
                name: formValueObj.name?.trim(),
                config: {
                    dayIndexMin: formValueObj.dayIndexMin ? Number(formValueObj.dayIndexMin) : 0,
                    dayIndexMax: formValueObj.dayIndexMax ? Number(formValueObj.dayIndexMax) : 0,
                },
            };

            let response;

            if (actionType === ActionType.CREATE) {
                response = await createCollectionConfig(requestModel);
            } else if (actionType === ActionType.UPDATE) {
                response = await updateCollectionConfig(currentConfig.id, requestModel);
            }
            setLoadingBtn(false);
            if (response?.status === 200) {
                onSuccess();
                onClose();
                return;
            }
        } catch (err) {
            console.log(err);
            onFailure(err);
        }
        setLoadingBtn(false);
    }

    return (
        <Drawer
            title={(actionType === ActionType.UPDATE ? "Update" : "Create") + " Collection Config"}
            className='story-drawer'
            width={750}
            onClose={() => {
                if (actionType === ActionType.CREATE) {
                    setdDrawerVisibility(false)
                } else {
                    onClose()
                }
            }}
            open={drawerVisibility}
            closeIcon={false}
            footer={
                <div className='d-flex justify-content-center'>
                    <Button onClick={saveConfig} type="primary" className='me-3' disabled={!submittables}
                            loading={loadingBtn}>
                        Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </div>
            }
        >
            {contextHolder}
            <Form layout="vertical" autoComplete='off' form={form}>
                {/* <Divider orientation="left" className='text-danger'>01. COLLECTION INFORMATION</Divider> */}
                <Row gutter={16} className='mb-3'>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label="Config Name"
                            rules={storyCollectionDrawerValidation.name}
                        >
                            <Input placeholder="Please enter config name" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="dayIndexMin"
                            label="Day MIN"
                            rules={storyCollectionDrawerValidation.dayIndexMin}
                        >
                            <Input placeholder="Please enter day MIN" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="dayIndexMax"
                            label="Day MAX"
                            rules={storyCollectionDrawerValidation.dayIndexMax}
                        >
                            <Input placeholder="Please enter day MAX" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )

}

export default CollectionConfigDrawer;
